import { render } from "./search-box-input.vue?vue&type=template&id=03af4435&lang=pug"
import script from "./search-box-input.vue?vue&type=script&lang=js"
export * from "./search-box-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__